import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { history } from '../../utils/helpers';
import { Row, Col } from 'react-bootstrap';
import { MdMenu } from "react-icons/md";
import { FaUser } from "react-icons/fa";

const onPaths = (paths) => {
  return (match, location) => {
    return paths.includes(location.pathname);
  };
}

const PageHeader = (props) => {
  const { location } = history;
  return (
    <>
      <div class="page-header-content">
        <Row>
          <Col sm={12} md={6}>
          <h2 className="page-header-title">{props.title}</h2>
          </Col>
          <Col sm={12} md={6}>
            <div className="">
              <ul className="navbar-nav m-auto stepper stepper-horizontal">
                <li className="step">
                  <NavLink exact className="nav-link" to="/activate">
                    <span className="circle active">1</span>
                  </NavLink>
                </li>
                <li className="line"></li>
                <li className="step">
                  <NavLink exact className="nav-link" to="/activate/step/two">
                    <span className="circle">2</span>
                  </NavLink>
                </li>
                <li className="line"></li>
                <li className="step">
                  <NavLink exact className="nav-link" to="/activate/step/three">
                    <span className="circle">3</span>
                  </NavLink>
                </li>
                <li className="line"></li>
                <li className="step">
                  <NavLink exact className="nav-link" to="/activate/step/four">
                    <span className="circle">4</span>
                  </NavLink>
                </li>
                <li className="line"></li>
                <li className="step">
                  <NavLink exact className="nav-link" to="/activate/step/five">
                    <span className="circle">5</span>
                  </NavLink>
                </li>
                <li className="line"></li>
                <li className="step">
                  <NavLink exact className="nav-link" to="/activate/step/six">
                    <span className="circle">6</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default PageHeader;

